module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" x=\"0px\" y=\"0px\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" enable-background=\"new 0 0 24 24\" xml:space=\"preserve\" stroke=\"currentColor\" fill=\"none\">\r\n<line stroke-width=\"2\" stroke-miterlimit=\"10\" x1=\"4\" y1=\"4\" x2=\"20\" y2=\"20\"/>\r\n<line stroke-width=\"2\" stroke-miterlimit=\"10\" x1=\"20\" y1=\"4\" x2=\"4\" y2=\"20\"/>\r\n</svg>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/icons/CLS.svg
// module id = 15
// module chunks = 0 1